import Image from "next/image";

import PropTypes from "prop-types";

import PrimaryBtn from "@/components/actions/button/primaryBtn";

export const HeroFeedback = (props) => {
  const {
    title,
    imageURL,
    description,
    buttonText,
    buttonHandler,
    imageAltText,
  } = props;

  return (
    <div className="flex flex-col items-center justify-center gap-[1.25rem] py-5">
      <Image
        width={180}
        height={180}
        src={imageURL}
        alt={imageAltText}
        quality={40}
      />

      <div className="flex flex-col items-center justify-center">
        {title && (
          <h3 className="mt-[1rem] text-[1.125rem] font-semibold tracking-[0.023rem] text-grayDisplay-400">
            {title}
          </h3>
        )}

        {description && (
          <p className="mt-[0.875rem] max-w-[23.75rem] text-center text-[0.875rem] text-grayDisplay-300">
            {description}
          </p>
        )}

        {buttonText && (
          <PrimaryBtn
            btnText={buttonText}
            onClick={buttonHandler}
            className="mt-[1.5rem] h-[2.5rem] w-[15rem]"
          />
        )}
      </div>
    </div>
  );
};

HeroFeedback.propTypes = {
  title: PropTypes.string,
  imageURL: PropTypes.string,
  description: PropTypes.string,
  imageAltText: PropTypes.string,
  buttonText: PropTypes.string,
  buttonHandler: PropTypes.func,
};
